export const allIndicatorsSubcategory = [
    // Perkins Indicators
    {
      label: "1S1 - Graduation",
      value: "1S1: Four-Year Graduation Rate",
      category: "Perkins V Indicators",
      database: "perkinsIndicators_2025",
      aggDatabase: "perkinsIndicators_2025",
      title:
        "The percentage of CTE concentrators who graduate high school, as measured by the four-year adjusted cohort graduation rate.",
      subtitle: "CTE concentrators graduated from high school on time.",
      caption: "The percent of students",
    },
    {
      label: "1S2 - Graduation Ext.",
      value: "1S2: Extended Graduation Rate",
      category: "Perkins V Indicators",
      database: "perkinsIndicators_2025",
      aggDatabase: "perkinsIndicators_2025",
      title:
        "The percentage of CTE concentrators who graduate high school, as measured by the extended-year adjusted cohort graduation rate",
      subtitle: "Students Enrolled in Any Dual Credit Option",
      caption: "The percent of students",
    },
    {
      label: "2S1 - Reading",
      value: "2S1: Academic Proficiency in Reading/Language Arts",
      category: "Perkins V Indicators",
      database: "perkinsIndicators_2025",
      aggDatabase: "perkinsIndicators_2025",
      title:"CTE concentrator proficiency in reading/language arts (ESEA §§1111(b)(1) and 1111(b)(2)).",
      subtitle: "CTE concentrators who are proficient in reading/language arts.",
      caption: `If a student withdraws at any point in their high school career, they will still contribute to the denominator. If a student achieves concentrator status at any time during high school, the student will be identified as a concentrator for the 1S1 indicator...`,
    },
    {
      label: "2S2 - Math",
      value: "2S2: Academic Proficiency in Mathematics",
      category: "Perkins V Indicators",
      database: "perkinsIndicators_2025",
      aggDatabase: "perkinsIndicators_2025",
      title:
       "CTE concentrator proficiency in mathematics (ESEA §§1111(b)(1) and 1111(b)(2)).",
      subtitle: "CTE concentrators who are proficient in mathematics.",
      caption: "The percent of students",
    },
    {
      label: "2S3 - Science",
      value: "2S3: Academic Proficiency in Science",
      category: "Perkins V Indicators",
      database: "perkinsIndicators_2025",
      aggDatabase: "perkinsIndicators_2025",
      title:
       "CTE concentrator proficiency in science (ESEA §§1111(b)(1) and 1111(b)(2)).",
      subtitle: "CTE concentrators who are proficient in science.",
      caption: "The percent of students",
    },
    {
      label: "4S1 - Non-Trad Enrollment",
      value: "4S1: Non-traditional Program Enrollment",
      category: "Perkins V Indicators",
      database: "perkinsIndicators_2025",
      aggDatabase: "perkinsIndicators_2025",
      title:
        "The percentage of CTE concentrators in career and technical education programs and programs of study that lead to non-traditional fields.",
      subtitle: "CTE concentrators enrolled in non-traditional programs.",
      caption: "The percent of students",
    },
    {
      label: "5S1 - Postsecondary Credential",
      value: "5S1: Program Quality - Attained Recognized Postsecondary Credential.",
      category: "Perkins V Indicators",
      database: "perkinsIndicators_2025",
      aggDatabase: "perkinsIndicators_2025",
      title:
        "The percentage of CTE concentrators graduating from high school having attained a recognized postsecondary credential.",
      subtitle: "CTE concentrators who have attained a recognized postsecondary credential.",
      caption: "The percent of students",
    },
    {
      label: "5S2 - Postsecondary Credits",
      value: "5S2: Program Quality - Attained Postsecondary Credits",
      category: "Perkins V Indicators",
      database: "perkinsIndicators_2025",
      aggDatabase: "perkinsIndicators_2025",
      title:
        "The percentage of CTE concentrators graduating from high school having attained postsecondary credits in the relevant career and technical education program or program of study earned through a dual or concurrent enrollment or another credit transfer agreement.",
      subtitle: "CTE concentrators who have attained postsecondary credits.",
      caption: "The percent of students",
    },
    {
      label: "5S3 - Work-Based Learning",
      value: "5S3: Program Quality - Participated in Work-Based Learning.",
      category: "Perkins V Indicators",
      database: "perkinsIndicators_2025",
      aggDatabase: "perkinsIndicators_2025",
      title:
        "The percentage of CTE concentrators graduating from high school having participated in work-based learning.",
      subtitle: "CTE concentrators who have participated in work-based learning.",
      caption: "The percent of students",
    },
    // Dual Credit Indicators
    {
      label: "Any Dual Credit",
      value: "Any Dual Credit",
      category: "Dual Credit",
      database: "indicators_dualCredit_any",
      aggDatabase: "indicatorsAgg23_dualCredit_any",
      title: "Percent of Students Enrolled in Any Dual Credit Option",
      subtitle: "Students Enrolled in Any Dual Credit Option",
      caption: "The percent of students",
    },
    {
      label: "CTE Dual Credit (Tech Prep)",
      value: "CTE Dual Credit",
      category: "Dual Credit",
      database: "indicators_dualCredit_techPrep",
      aggDatabase: "indicatorsAgg23_dualCredit_techPrep",
      title: "Percent of Students Enrolled in CTE Dual Credit (Tech Prep)",
      subtitle: "Students Enrolled in Any Dual Credit Option",
      caption: "Percent of Students Enrolled in CTE Dual Credit (Tech Prep) Option",
    },
    {
      label: "Running Start",
      value: "Running Start",
      category: "Dual Credit",
      database: "indicators_dualCredit_runningStart",
      aggDatabase: "indicatorsAgg_dualCredit_runningStart",
      title: "Percent of Students Enrolled in Running Start",
      caption: "The percent of students",
    },
    {
      label: "Advanced Placement",
      value: "Advanced Placement",
      category: "Dual Credit",
      database: "indicators_dualCredit_AP",
      aggDatabase: "indicatorsAgg_dualCredit_AP",
      title: "Percent of Students Enrolled in Advanced Placement",
      caption: "The percent of students",
    },
    {
      label: "International Baccalaureate",
      value: "International Baccalaureate",
      category: "Dual Credit",
      database: "indicators_dualCredit_IB",
      aggDatabase: "indicatorsAgg_dualCredit_IB",
      title: "Percent of Students Enrolled in International Baccalaureate",
      caption: "The percent of students",
    },
    {
      label: "College in the High School",
      value: "College in the High School",
      category: "Dual Credit",
      database: "indicators_dualCredit_CHS",
      aggDatabase: "indicatorsAgg_dualCredit_CHS",
      title: "Percent of Students Enrolled in College in the High School",
      caption: "The percent of students",
    },
    {
      label: "Cambridge",
      value: "Cambridge",
      category: "Dual Credit",
      database: "indicators_dualCredit_Cambridge",
      aggDatabase: "indicatorsAgg_dualCredit_cambridge",
      title: "Percent of Students Enrolled in Cambridge",
      caption: "The percent of students",
    },
  ];

  export const allIndicatorsCategory = [
    {
      label: "Perkins V Indicators",
      value: "Perkins V Indicators",
      disabled: false,
    },
    {
      label: "Dual Credit",
      value: "Dual Credit",
      disabled: false,
    },
    {
      label: "Ninth Grade on Track",
      database: "indicators_ninthGradeOnTrack",
      value: "Ninth Grade on Track",
      disabled: false,
      aggDatabase: "indicatorsAgg_ninthGradeOnTrack",
      title: "Percent of Ninth Grade Students Passing All Courses",
      subtitle: "First Time 9th Grade Students (Excluding Withdrawals) Passing All Credits Attempted",
      caption: "The percent of students"
    },


    {
      label: "Regular Attendance",
      value: "Regular Attendance",
      database: "indicators_regularAttendance",
      aggDatabase: "indicatorsAgg_regularAttendance",
      disabled: false,
      title: "Percent of Students Present for at Least 90% of School Days",
      subtitle: "Students Present for at least 90% of School Days",
      caption: `% of students present for at least 90% of school days, or missing fewer than of 2 days per month on average.
      This includes excused and unexcused absences, and any absence where a student misses 50% or more of the school day.`
    },


  ];